const locale = {
  VALIDATE_TITLE_TEXT: 'Verification successful',
  VALIDATE_DESCRIPTION_TEXT: 'The code has been validated successfully.',
  SET_TITLE_TEXT: 'Code sent',
  SET_DESCRIPTION_TEXT: 'Check your email to enter the code.',
  RESEND_TITLE_TEXT: 'Code resent',
  RESEND_DESCRIPTION_TEXT: 'A new code has been sent. Check your inbox.',
  ERROR_TITLE_TEXT: 'Error',
  ERROR_DESCRIPTION_TEXT: 'Something went wrong. Please try again.',
};

export default locale;
